import { API_URL } from '../config/api';

function checkAuthError(response) {
    if (response.status === 401 || response.status === 403) {
        throw new Error('Nemáte oprávnění. Přihlaste se prosím znovu.');
    }
}

export const getAllQuestions = async (page = 0, size = 12) => {
    const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString()
    });
    const response = await fetch(`${API_URL}/questions?${params}`, {
        credentials: 'include',
    });

    if (!response.ok) {
        throw new Error('Nepodařilo se načíst otázky');
    }

    return response.json();
};

export const filterQuestionsByType = async (questionType, page = 0, size = 12) => {
    const params = new URLSearchParams({
        questionType: questionType,
        page: page.toString(),
        size: size.toString()
    });
    const response = await fetch(`${API_URL}/questions/filter?${params}`, {
        credentials: 'include',
    });

    if (!response.ok) {
        throw new Error('Nepodařilo se načíst otázky');
    }

    return response.json();
};

export const getQuestionById = async (questionId) => {
    const response = await fetch(`${API_URL}/questions/${questionId}`, {
        credentials: 'include',
    });

    if (!response.ok) {
        throw new Error('Nepodařilo se načíst otázku');
    }

    return response.json();
};

export const deleteQuestion = async (questionId) => {
    const response = await fetch(`${API_URL}/questions/${questionId}`, {
        method: 'DELETE',
        credentials: 'include',
    });

    if (!response.ok) {
        throw new Error('Nepodařilo se smazat otázku');
    }
};

export const updateMultichoiceQuestion = async (questionId, questionData) => {
    const response = await fetch(`${API_URL}/questions/multichoice/${questionId}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(questionData),
    });

    if (!response.ok) {
        checkAuthError(response);
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Nepodařilo se upravit otázku');
    }

    return response.json();
};

export const createMultichoiceQuestion = async (questionData) => {
    const response = await fetch(`${API_URL}/questions/multichoice`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(questionData),
    });

    if (!response.ok) {
        checkAuthError(response);
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Nepodařilo se vytvořit otázku');
    }

    return response.json();
};

export const createMultipleCorrectQuestion = async (questionData) => {
    const response = await fetch(`${API_URL}/questions/multiresponse`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(questionData),
    });

    if (!response.ok) {
        checkAuthError(response);
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Nepodařilo se vytvořit otázku');
    }

    return response.json();
};

export const updateMultipleCorrectQuestion = async (questionId, questionData) => {
    const response = await fetch(`${API_URL}/questions/multiresponse/${questionId}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(questionData),
    });

    if (!response.ok) {
        checkAuthError(response);
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Nepodařilo se upravit otázku');
    }

    return response.json();
};

export const createFillInQuestion = async (questionData) => {
    const response = await fetch(`${API_URL}/questions/fillin`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(questionData),
    });

    if (!response.ok) {
        checkAuthError(response);
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Nepodařilo se vytvořit otázku');
    }

    return response.json();
};

export const updateFillInQuestion = async (questionId, questionData) => {
    const response = await fetch(`${API_URL}/questions/fillin/${questionId}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(questionData),
    });

    if (!response.ok) {
        checkAuthError(response);
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Nepodařilo se upravit otázku');
    }

    return response.json();
};

export const createTimelineQuestion = async (questionData) => {
    const response = await fetch(`${API_URL}/questions/timeline`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(questionData),
    });

    if (!response.ok) {
        checkAuthError(response);
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Nepodařilo se vytvořit otázku');
    }

    return response.json();
};

export const updateTimelineQuestion = async (questionId, questionData) => {
    const response = await fetch(`${API_URL}/questions/timeline/${questionId}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(questionData),
    });

    if (!response.ok) {
        checkAuthError(response);
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Nepodařilo se upravit otázku');
    }

    return response.json();
};

export const createLinkingQuestion = async (questionData) => {
    const response = await fetch(`${API_URL}/questions/linking`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(questionData),
    });

    if (!response.ok) {
        checkAuthError(response);
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Nepodařilo se vytvořit otázku');
    }

    return response.json();
};

export const updateLinkingQuestion = async (questionId, questionData) => {
    const response = await fetch(`${API_URL}/questions/linking/${questionId}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(questionData),
    });

    if (!response.ok) {
        checkAuthError(response);
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Nepodařilo se upravit otázku');
    }

    return response.json();
};

export const createFindInTextQuestion = async (questionData) => {
    const response = await fetch(`${API_URL}/questions/findintext`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(questionData),
    });

    if (!response.ok) {
        checkAuthError(response);
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Nepodařilo se vytvořit otázku');
    }

    return response.json();
};

export const searchQuestions = async ({ authorId, readingJournalId, unlinked, page = 0, size = 12 } = {}) => {
    const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString()
    });
    if (authorId) params.append('authorId', authorId);
    if (readingJournalId) params.append('readingJournalId', readingJournalId);
    if (unlinked) params.append('unlinked', 'true');

    const response = await fetch(`${API_URL}/questions/search?${params}`, {
        credentials: 'include',
    });

    if (!response.ok) {
        throw new Error('Nepodařilo se vyhledat otázky');
    }

    return response.json();
};

export const getQuestionsByJournal = async (journalId) => {
    const response = await fetch(`${API_URL}/questions/by-journal/${journalId}`, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) throw new Error('Nepodařilo se načíst otázky pro knihu');
    const data = await response.json();
    return Array.isArray(data) ? data : (data.content || []);
};

export const updateFindInTextQuestion = async (questionId, questionData) => {
    const response = await fetch(`${API_URL}/questions/findintext/${questionId}`, {
        method: 'PUT',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(questionData),
    });

    if (!response.ok) {
        checkAuthError(response);
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || 'Nepodařilo se upravit otázku');
    }

    return response.json();
};
